/**
 * 初期パスワード変更
 */
import * as httpConst from '../../../constants/httpConst'
import Vue from 'vue'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/initial_password`

const initial_password = {
  namespaced: true,
  actions: {
    update ({ commit },{ params }) {
      const api_path = `${API_PATH}/`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default initial_password

